export const PAGE_NAMES = {
    Overview: 'MyTradera',
    BuyerActiveItems: 'MyTradera_ActiveBids',
    BuyerItemsLost: 'MyTradera_LostBids',
    MyTraderaLeaveFeedback: 'MyTradera_LeaveFeedback',
    SellerActive: 'MyTradera_ActiveItems',
    SellerSold: 'MyTradera_SoldItems',
    SellerUnsold: 'MyTradera_UnsoldItems',
    BuyerPurchases: 'MyTradera_Purchases',
    Profile: 'MyTradera_Profile',
    Settings: 'MyTradera_Settings',
    SettingsAccount: 'MyTradera_SettingsAccount',
    SettingsEmail: 'MyTradera_SettingsEmail',
    SettingsNotifications: 'MyTradera_SettingsNotifications',
    SettingsSeller: 'MyTradera_SettingsSeller',
    SettingsSecurity: 'MyTradera_SettingsSecurity'
};
